import {
  POSITION_SLOT_LIFECYCLE,
  POSITION_SLOT_OCCUPANCY,
  POSITION_SLOT_SECONDARY_COMPETENCY_LEVELS,
  POSITION_SLOT_WORKER_TYPE,
  POSITION_SLOT_WORKER_TYPE_LABELS,
} from 'domain/shared/positionSlot';

export {
  POSITION_SLOT_LIFECYCLE,
  POSITION_SLOT_OCCUPANCY,
  POSITION_SLOT_WORKER_TYPE,
  POSITION_SLOT_WORKER_TYPE_LABELS,
};

export const POSITION_SLOT_LIFECYCLE_LABELS: Dictionary<string> = {
  [POSITION_SLOT_LIFECYCLE.ACTIVE]: 'Active',
  [POSITION_SLOT_LIFECYCLE.FROZEN]: 'Frozen',
  [POSITION_SLOT_LIFECYCLE.RETIRED]: 'Retired',
};

export const DEFAULT_POSITION_SLOT_LIFECYCLE_FILTER = [POSITION_SLOT_LIFECYCLE.ACTIVE, POSITION_SLOT_LIFECYCLE.FROZEN];

export const POSITION_SLOT_WORKER_TYPE_CREATE_LABELS: Dictionary<string> = {
  [POSITION_SLOT_WORKER_TYPE.STAFF]: 'Staff',
  [POSITION_SLOT_WORKER_TYPE.CONTRACTOR]: 'Contractor',
};

export const POSITION_SLOT_WORKER_TYPE_EXCEPTION_TOOLTIP =
  'Legacy position for a worker who has a B2B or CFS contract, but employee worker type.';

export const POSITION_SLOT_READ = 'PEOPLE_MANAGEMENT_POSITION_SLOT_READ_LIST';
export const POSITION_SLOT_LIST_READ = 'PEOPLE_MANAGEMENT_POSITION_SLOT_LIST_READ_LIST';
export const POSITION_SLOT_CREATE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_CREATE';
export const POSITION_SLOT_UPDATE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_UPDATE';
export const POSITION_SLOT_ASSIGN = 'PEOPLE_MANAGEMENT_POSITION_SLOT_ASSIGN';
export const POSITION_SLOT_FREEZE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_FREEZE';
export const POSITION_SLOT_UNFREEZE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_UNFREEZE';
export const POSITION_SLOT_RETIRE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_RETIRE';
export const POSITION_SLOT_EMPLOYEE_VALIDATION = 'PEOPLE_MANAGEMENT_CONTRACT_LIST_VALIDATE_POSITION_SLOTS';

export const SECONDARY_COMPETENCY_LEVEL_OPTIONS: Dictionary<string> = POSITION_SLOT_SECONDARY_COMPETENCY_LEVELS;
